const Map = () => {
  return (
    <div className='w-full flex flex-col-reverse md:flex-row h-full items-center relative z-10'>
      <div className='w-full md:w-[40%] h-full pl-[3vw] border-t-[0.2vw] md:border-t-0  md:border-l-[0.2vw] border-white py-[3vw]'>
      <div className='w-full h-full flex flex-col md:gap-[2vw] gap-4'>
        <div className='w-full h-full flex flex-col items-center md:items-start md:gap-[1vw]'>
            <h1 className='text-4xl text-center md:text-start md:text-[3.75vw] font-extrabold flex items-center'>10+</h1>
            <p className='text-xl text-center md:text-start md:leading-none flex items-center'>countries covered</p>
        </div>
        <div className='w-full h-full flex flex-col items-center md:items-start md:gap-[1vw]'>
            <h1 className='text-4xl text-center md:text-start md:text-[3.75vw] font-extrabold flex items-center'>200+</h1>
            <p className='text-xl text-center md:text-start md:leading-none flex items-center'>happy clients</p>
        </div>
        <div className='w-full h-full flex flex-col items-center md:items-start md:gap-[1vw]'>
            <h1 className='text-4xl text-center md:text-start md:text-[3.75vw] font-extrabold flex items-center'>300,000+</h1>
            <p className='text-xl text-center md:text-start md:leading-none flex items-center'>units delivered</p>
        </div>
      </div>
      </div>
      <div className='w-full md:w-[60%] h-full overflow-hidden py-12 md:py-0 scale-110 md:scale-100'>
      <img src="/Home/world_map_pins.svg" alt="" className='w-full h-full object-cover' /></div>
    </div>
  )
}

export default Map
